// Punjabi translations
export const pa: Record<string, string> = {
  'menu.dashboard': 'ਡੈਸ਼ਬੋਰਡ',
  'menu.customers': 'ਗਾਹਕ',
  'menu.products': 'ਉਤਪਾਦ',
  'menu.users': 'ਉਪਭੋਗਤਾ',
  'menu.settings': 'ਸੈਟਿੰਗਾਂ',
  'menu.logout': 'ਲਾੱਗ ਆਉਟ',
  'dashboard.title': 'ਡੈਸ਼ਬੋਰਡ',
  'dashboard.newOrder': 'ਨਵਾਂ ਆਰਡਰ',
  'order.title': 'ਨਵਾਂ ਆਰਡਰ',
  'order.customer': 'ਗਾਹਕ',
  'order.products': 'ਉਤਪਾਦ',
  'order.total': 'ਕੁੱਲ',
  'users.title': 'ਉਪਭੋਗਤਾ',
  'users.name': 'ਨਾਮ',
  'users.email': 'ਈਮੇਲ',
  'common.yes': 'ਹਾਂ',
  'common.no': 'ਨਹੀਂ',
  'common.cancel': 'ਰੱਦ ਕਰੋ',
  'common.save': 'ਸੁਰੱਖਿਅਤ ਕਰੋ',
  'common.search': 'ਖੋਜੋ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ਲਾੱਗਇਨ',
  'login.welcome': 'ਸੁਆਗਤ ਹੈ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ਈਮੇਲ',
  'signup.phone': 'ਫ਼ੋਨ',
  'menu.reportsAndAccounting': 'ਰਿਪੋਰਟਾਂ ਅਤੇ ਲੇਖਾ',
  'menu.systemAndCommunication': 'ਸਿਸਟਮ ਅਤੇ ਸੰਚਾਰ',
};